export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20pair%20of%20modern%20lifestyle%20sneakers%20in%20warm%20cream%20and%20beige%20tones%20placed%20on%20a%20pristine%20white%20surface%2C%20soft%20diffused%20natural%20studio%20lighting%2C%20elegant%20editorial%20ecommerce%20composition%2C%20minimalist%20aesthetic%20with%20visible%20material%20texture%20and%20detail%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-shoes-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneakers, trainers & athletic footwear finds',
    featured: true,
  },
  {
    id: 'hoodies-sweaters',
    name: 'Hoodies/Sweaters',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20soft%20oversized%20hoodie%20in%20oatmeal%20beige%20tone%20folded%20neatly%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%20with%20gentle%20shadows%2C%20editorial%20ecommerce%20composition%2C%20visible%20knit%20texture%20and%20fabric%20weight%2C%20minimalist%20warm%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-hoodies-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies & premium sweaters',
    featured: true,
  },
  {
    id: 't-shirts',
    name: 'T-Shirts',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20premium%20cotton%20tshirt%20in%20warm%20sand%20beige%20color%20folded%20elegantly%20on%20a%20pure%20white%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20minimalist%20ecommerce%20composition%2C%20visible%20fabric%20texture%20and%20quality%20stitching%20detail%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-tshirts-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Graphic tees & essential basics',
    featured: false,
  },
  {
    id: 'jackets',
    name: 'Jackets',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20stylish%20light%20bomber%20jacket%20in%20warm%20taupe%20tone%20laid%20flat%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20stitching%20and%20material%20quality%20detail%2C%20minimalist%20contemporary%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-jackets-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Outerwear, bombers & varsity jackets',
    featured: true,
  },
  {
    id: 'pants-shorts',
    name: 'Pants/Shorts',
    icon: 'ri-checkbox-blank-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20pair%20of%20casual%20cargo%20pants%20in%20soft%20khaki%20beige%20tone%20folded%20neatly%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20fabric%20texture%20and%20pocket%20detail%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-pants-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Cargo pants, denim & summer shorts',
    featured: false,
  },
  {
    id: 'headwear',
    name: 'Headwear',
    icon: 'ri-user-5-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20stylish%20baseball%20cap%20in%20warm%20cream%20tone%20placed%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20stitching%20and%20curved%20brim%20detail%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-headwear-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies & bucket hats',
    featured: false,
  },
  {
    id: 'sets',
    name: 'Sets',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20coordinated%20matching%20tracksuit%20set%20in%20soft%20beige%20tone%20folded%20together%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20fabric%20texture%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-sets-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Matching tracksuits & coordinated sets',
    featured: false,
  },
  {
    id: 'underwear',
    name: 'underwear/underpants',
    icon: 'ri-check-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20premium%20cotton%20underwear%20in%20soft%20neutral%20beige%20folded%20neatly%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20fabric%20quality%20detail%2C%20minimalist%20clean%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-underwear-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Underwear, boxers & basics',
    featured: false,
  },
  {
    id: 'jersey',
    name: 'Jersey',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20sports%20jersey%20in%20warm%20cream%20tone%20with%20subtle%20perforated%20fabric%20detail%20laid%20flat%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20athletic%20material%20texture%20visible%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-jersey-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys & team apparel',
    featured: false,
  },
  {
    id: 'accessories',
    name: 'Accessories',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20sunglasses%20and%20a%20minimalist%20bracelet%20arranged%20elegantly%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20warm%20neutral%20tones%2C%20sophisticated%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-accessories-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Sunglasses, chains & wristwear',
    featured: false,
  },
  {
    id: 'bags',
    name: 'Bags',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20structured%20canvas%20tote%20bag%20in%20warm%20sand%20beige%20tone%20standing%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20material%20texture%20and%20stitching%20detail%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-bags-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, totes & crossbody bags',
    featured: true,
  },
  {
    id: 'belts',
    name: 'Belts',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20premium%20leather%20belt%20in%20warm%20cognac%20tone%20coiled%20elegantly%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20leather%20grain%20texture%20and%20buckle%20detail%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-belts-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Designer belts & leather accessories',
    featured: false,
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20an%20elegant%20minimalist%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20visible%20glass%20texture%20and%20subtle%20reflections%2C%20sophisticated%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-perfumes-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragrances & luxury scents',
    featured: false,
  },
  {
    id: 'other-stuff',
    name: 'Other Stuff',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20an%20assortment%20of%20lifestyle%20accessories%20including%20a%20wallet%20and%20keychain%20arranged%20artfully%20on%20a%20pure%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20warm%20neutral%20tones%2C%20minimalist%20aesthetic%2C%20no%20visible%20branding&width=400&height=300&seq=cat-img-other-v2&orientation=landscape',
    href: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Everything else worth checking out',
    featured: false,
  },
];

export const featuredCategories = categories.filter((c) => c.featured);